<app-core-api-hero></app-core-api-hero>
<app-common-companies-panel
  [companiesData]="companiesData"
></app-common-companies-panel>
<app-banking-operations></app-banking-operations>
<app-robust-core-apis></app-robust-core-apis>
<app-transactional-fx></app-transactional-fx>
<app-powerful-apis></app-powerful-apis>
<app-customer-onboarding></app-customer-onboarding>
<app-common-discover-why
  [discoverData]="discoverData"
></app-common-discover-why>
<app-common-faq [faqData]="faqData"></app-common-faq>
<app-common-latest-news
  [blogData]="newsList"
  [isWhiteBg]="true"
></app-common-latest-news>
<app-common-ready-to [readyToData]="readyToData"></app-common-ready-to>
<app-common-explore-global-panel
  [exploreData]="exploreMore"
></app-common-explore-global-panel>
<!-- <app-api-core-faq></app-api-core-faq>
<app-api-core-insights></app-api-core-insights>
<app-api-core-get-started></app-api-core-get-started>
<app-api-core-global></app-api-core-global> -->
